import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Button from 'UIKit/Button'
import Text from 'UIKit/Text'
import useDebounce from 'hooks/useDebounce'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import SearchContent from './SearchContent'
import { AppSearch } from './styled'

const SearchInput: React.FC<{ onValueChanged: (text: string) => void; value: string }> = ({
  onValueChanged,
  value,
}) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()

  return (
    <AppSearch
      id="search-input"
      autoFocus={!isMobile}
      onValueChanged={onValueChanged}
      value={value}
      width="100%"
      placeholder={`${t('Search your game')}`}
    />
  )
}

const SearchLayout: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  const [searchText, setSearchText] = useState('')
  const debouncedSearch = useDebounce(searchText, 600)

  return (
    <Box>
      <StyledContainer id="searchLayout-topbar" px={['12px', '', '0px']}>
        <Flex alignItems="center" height="100%">
          <SearchInput onValueChanged={setSearchText} value={searchText} />
          <StyledCloseButtonContainer ml={['12px']} display={['block', '', '', 'none']}>
            <Button id="close" variant="text" onClick={onClose}>
              <Text small>
                <Trans>Cancel</Trans>
              </Text>
            </Button>
          </StyledCloseButtonContainer>
        </Flex>
      </StyledContainer>
      <WrapContent id="searchLayout-content">
        <SearchContent searchText={debouncedSearch} setSearchText={setSearchText} />
      </WrapContent>
    </Box>
  )
}
const StyledContainer = styled(Box)`
  height: ${({ theme }) => theme.topbarHeight};
  width: 100%;
`

const WrapContent = styled(Box)`
  height: auto;
  border-radius: ${({ theme }) => theme.radii.extraLarge};
  background-color: unset;
  max-height: var(--screen-height);

  ${({ theme }) => theme.mediaQueries.sm} {
    max-height: 75vh;
  }
`
const StyledCloseButtonContainer = styled(Box)`
  position: static;
`
export default React.memo(SearchLayout)
